<template lang="pug">
.venue-cards-list
	.columns.is-multiline.is-mobile(v-if="venues")
		VenueCardItem.column.is-6-mobile.is-6-tablet.is-4-desktop.is-3-widescreen.is-3-fullhd(
			v-for="venue in venues"
			:key="venue.id"
			:venue="venue"
			:date="dateObject"
			@click="handleItemClick(venue)"
		)
</template>

<script setup lang="ts">
const props = defineProps({
	venues: {
		type: Object,
		required: true
	},
	source: {
		type: String,
		required: false
	}
})

const emit = defineEmits(['item-clicked'])

const handleItemClick = (venue: Venue) => {
	emit('item-clicked', {
		venue,
		...(props.source && { source: props.source })
	})
}

const date = new Date()
const dateObject = ref({
	now: date,
	weekday: date.getDay() === 0 ? 7 : date.getDay(),
	currentTime: date.toLocaleTimeString('en-GB')
})
</script>

<style lang="sass" scoped>
.venue-cards-list
	@media (max-width: 450px)
		.venue-card-wrapper
			width: 100%
</style>
